import { FetchUserAttributesOutput, JWT } from 'aws-amplify/auth';

// Claims Cognito adds to every ID token that are not user attributes. The second
// group only appears on hosted-UI and federated sign-ins.
const TOKEN_ONLY_CLAIMS = new Set([
  'aud',
  'auth_time',
  'cognito:groups',
  'cognito:username',
  'event_id',
  'exp',
  'iat',
  'iss',
  'jti',
  'origin_jti',
  'token_use',
  'at_hash',
  'cognito:preferred_role',
  'cognito:roles',
  'identity_provider',
  'nonce',
  'sid',
]);

// The shape fetchUserAttributes() returns: every value a string, structured claims
// such as `identities` serialised the way the user pool stores them.
export const attributesFromIdToken = (
  payload: JWT['payload'],
): FetchUserAttributesOutput =>
  Object.fromEntries(
    Object.entries(payload)
      .filter(([claim]) => !TOKEN_ONLY_CLAIMS.has(claim))
      .map(([claim, value]) => [
        claim,
        typeof value === 'object' && value !== null
          ? JSON.stringify(value)
          : String(value),
      ]),
  );
